import { type UseQueryResult, useQuery } from 'react-query';
import {
  DashboardService,
  // eslint-disable-next-line camelcase
  type Wealthlane_ReportService_Dtos_AuditTrailsSummaryResponseDto,
} from '../../services/wealthlane-report-services';

const useGetParticipantDashboardReportSummary = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_ReportService_Dtos_AuditTrailsSummaryResponseDto | undefined,
  unknown
> => {
  const participantDashboardReportSummary = useQuery(
    ['getParticipantDashboardReportSummary'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        DashboardService.getApiReportApiAppDashboardParticipantDashboardSummary()
      );
    }
    // }
  );
  return participantDashboardReportSummary;
};

export default useGetParticipantDashboardReportSummary;
